export const siteConfig = {
  name: "Automate Analyze Innovate",
  shortName: "AAI",
  tagline: "Lead-to-revenue systems for service businesses",
  url: "https://www.automateanalyzeinnovate.com",
  title: "AAI | Lead Flow Diagnostics, Repairs, and Managed Operations",
  description:
    "AAI fixes the systems between a lead arriving and revenue being recorded for service businesses through diagnostics, repairs, managed operations, automation, analytics, and technical rescue.",
  primaryOfferUrl: "/lead-flow-tracking",
  bookingUrl: "/contact",
  consultationUrl: "https://calendly.com/automateanalyzeinnovate/reactivate-initial-consultation",
  consultationBookingEnabled: true,
  contactEmail: "support@automateanalyzeinnovate.com",
  logo: {
    lockup: "/assets/images/AutomateAnalyzeInnovateLogo.png",
    original: "/assets/images/AutomateAnalyzeInnovate.png",
    favicon: "/assets/images/AutomateAnalyzeInnovateFavicon.ico",
  },
} as const;

export const navLinks = [
  { name: "Lead Flow", href: "/lead-flow-tracking" },
  { name: "Operations", href: "/automation-operations" },
  { name: "Analytics", href: "/analytics-decision-systems" },
  { name: "Technical Rescue", href: "/websites-migrations-rescue" },
  { name: "Work", href: "/work" },
] as const;

export const sitemapPages = [
  { path: "/", priority: "1.0", changefreq: "weekly", lastmod: "2026-08-12" },
  { path: "/lead-flow-tracking", priority: "0.95", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/automation-operations", priority: "0.82", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/analytics-decision-systems", priority: "0.82", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/websites-migrations-rescue", priority: "0.8", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/work", priority: "0.78", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/services", priority: "0.86", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/industries", priority: "0.74", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/privacy", priority: "0.2", changefreq: "yearly", lastmod: "2026-08-12" },
  { path: "/terms", priority: "0.2", changefreq: "yearly", lastmod: "2026-08-12" },
] as const;
